module.exports = __webpack_public_path__ + "img/20200515_160608.5e6afaf4.jpg";